/*-----------------------------------------------
 共通JS
-----------------------------------------------*/

$(function () {
  ieAttentionDomDel();
  createHamburgerMenu();
  createAccordion();
  createPageTop();
  createTab();

  if (classFinder('[data-js="js-matchHeight"]')) {
    $('[data-js="js-matchHeight"]').matchHeight();
  }

  objectFitImages();

  //  $(window).on('load', function() {

  //    createAnchorScroll();
  clickAnchorScroll();
  movePageAnchor();

  //  });
});

//特定のID、クラスが存在するかどうかを確認（jQueryのlength）
function classFinder(el) {
  const target = document.querySelectorAll(el);

  if (target.length == 0) {
    return false;
  } else {
    return true;
  }
}

//IE以外でIEサポート終了アナウンスDOM削除
function ieAttentionDomDel() {
  let html = document.querySelector("html");
  let ieMsg = document.getElementById("ieAttention");
  if (ieMsg !== null) {
    if (!html.classList.contains("is-IE")) {
      ieMsg.parentNode.removeChild(ieMsg);
    }
  }
}

//id付きのリンクで飛ぶ時の位置調整
function movePageAnchor() {
  let hash = location.hash;
  let hash_target = $(hash);
  let hh = $(".l-header__inner").innerHeight();

  if (hash_target.length) {
    // ▼ 追加: CSSの scroll-margin-top を取得（設定がなければ0）
    let cssMargin = parseInt(hash_target.css("scroll-margin-top")) || 0;

    if (classFinder(['[data-js="js-matchHeight"]', "[data-mh]"])) {
      $.fn.matchHeight._afterUpdate = function (event, groups) {
        // ▼ 修正: hh に加えて cssMargin も引く
        let pos = hash_target.offset().top - hh - cssMargin;
        $("html,body").scrollTop(pos);
      };
    } else {
      // ▼ 修正: hh に加えて cssMargin も引く
      let pos = hash_target.offset().top - hh - cssMargin;
      $("html,body").scrollTop(pos);
    }
  } else {
    return;
  }
}

function clickAnchorScroll() {
  $('a[href^="#"]:not([class*="modal"])').on("click", function () {
    if ($(this).closest('[data-js="tab"]').length > 0) {
      return false;
    }

    var speed = 1000;
    var hh = $(".l-header__inner").innerHeight();
    var href = $(this).attr("href");
    var $target = $(href == "#" || href == "" ? "html" : href);

    if ($target.length) {
      // ▼ 追加: CSSの scroll-margin-top を取得
      var cssMargin = parseInt($target.css("scroll-margin-top")) || 0;

      // ▼ 修正: ヘッダー高さ(hh) と CSSマージン(cssMargin) の両方を引く
      var pos = $target.offset().top - hh - cssMargin;

      $("html, body").animate({ scrollTop: pos }, speed, "swing");
    }

    return false;
  });
}

function createAccordion() {
  $('[data-js="accordion"] .c-accordion__title').on("click", function () {
    $(this).toggleClass("is-accOpen");
    $("+.c-accordion__body", this).slideToggle();
  });
}

//  pageTop scroll
function createPageTop() {
  var $pagetop = $('a[data-js="pagetop"]');
  $pagetop.hide();
  window.addEventListener("scroll", function () {
    if ($(window).scrollTop() > 200) {
      $pagetop.fadeIn();
    } else {
      $pagetop.fadeOut();
    }
  });

  $pagetop.on("click", function (e) {
    e.preventDefault();
    $("html,body").animate({ scrollTop: 0 }, 1000);
    return false;
  });
}

// Tab
function createTab() {
  var t_item = $(
    '[data-js="tab"] .c-tab__select .c-tab__item > a:not([target="_blank"])'
  );
  var t_article = $('[data-js="tab"] .c-tab__body .c-tab__article');

  t_item.on("click", function (e) {
    e.preventDefault();
    var t_target = $(this).attr("href");
    //active付与
    $(this).parent().siblings().removeClass("is-active");
    $(this).parent().addClass("is-active");
    //show付与
    $(t_target).siblings().removeClass("is-show");
    $(t_target).addClass("is-show");
  });

  // hash付きで遷移した場合、対象のタブを表示
  var hash = location.hash;
  var t = $(
    '[data-js="tab"] .c-tab__select .c-tab__item > a[href="' + hash + '"]'
  );
  var hash_target = $(hash);
  if (hash.length) {
    t.parent().siblings().removeClass("is-active");
    t.parent().addClass("is-active");
    hash_target.siblings().removeClass("is-show");
    hash_target.addClass("is-show");
  }

  $(window).on("resize", function () {
    //横にスライドできます表記出現条件
    $('[data-js="tab"]').each(function () {
      var tab_item = $(this).find(".c-tab__item");
      var totalTabWidth = 0;
      tab_item.each(function () {
        totalTabWidth += tab_item.outerWidth();
      });
      if (totalTabWidth >= $(window).width()) {
        $(this).addClass("add_attention");
      } else {
        $(this).removeClass("add_attention");
      }
    });
  });
}


/**
 * スクロールバーの有無と画面幅に応じて root のフォントサイズを調整
 */
const adjustRootFontSize = () => {
  const html = document.documentElement;
  const width = window.innerWidth;
  const hasScrollbar = width > html.clientWidth;

  if (width <= 568) {
    // 568px以下のSPレイアウト
    html.style.fontSize = '3.947svw';
  } else if (width <= 960) {
    // 569px 〜 960pxのタブレット/中間レイアウト
    html.style.fontSize = '1.953svw';
  } else {
    // 961px以上のPCレイアウト
    if (hasScrollbar) {
      // スクロールバーあり
      html.style.fontSize = '1.0309svw';
    } else {
      // スクロールバーなし
      html.style.fontSize = '1.0416svw';
    }
  }
};

// 初期実行
adjustRootFontSize();

// リサイズ時に実行
window.addEventListener('resize', adjustRootFontSize);

// コンテンツの増減でスクロールバーが出現した場合にも対応
const observer = new MutationObserver(adjustRootFontSize);
observer.observe(document.body, { childList: true, subtree: true });